import React from "react";
import Hero from "../components/Hero";
import PickupBar from "../components/PickupBar";
import RatesSection from "../components/RatesSection";
import { AboutSection, NumbersSection } from "../components/AboutSection";
import ProcessSection from "../components/ProcessSection";
import WhyUsSection from "../components/WhyUsSection";
import TestimonialsSection from "../components/TestimonialsSection";
import MediaSection from "../components/MediaSection";
import SolutionsSection from "../components/SolutionsSection";
import BlogsSection from "../components/BlogsSection";
import FaqSection from "../components/FaqSection";
import AppDownloadSection from "../components/AppDownloadSection";
import CitiesSection from "../components/CitiesSection";

const Home = () => (
  <main>
    <Hero />
    <div className="pb-16 sm:pb-20 bg-gradient-to-br from-[#eef4fb] via-white to-[#fdf3e6]">
      <PickupBar />
    </div>
    <RatesSection />
    <AboutSection />
    <NumbersSection />
    <ProcessSection />
    <WhyUsSection />
    <TestimonialsSection />
    <MediaSection />
    <SolutionsSection />
    <BlogsSection />
    <FaqSection />
    <AppDownloadSection />
    <CitiesSection />
  </main>
);

export default Home;
